import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const MediaTaskTable = ({ data, currentPage, itemsPerPage }) => {
  const tableHead = [
    "Sr.",
    "Deadline",
    "Task Name",
    "Agency Name",
    "Instructions",
    "Submited Work",
    // "Task Created By",
    "Status",
    "Actions",
  ];

  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/media-task-view/${id}`);
  };

  //   const linkifyText = (text) => {
  //     if (!text) return "N/A";

  //     const urlRegex = /(https?:\/\/[^\s]+)/g;

  //     return text.split(urlRegex).map((part, index) => {
  //       if (part.match(urlRegex)) {
  //         return (
  //           <a key={index} href={part} target="_blank" rel="noopener noreferrer">
  //             {part}
  //           </a>
  //         );
  //       }
  //       return part;
  //     });
  //   };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return (
                <>
                  <th key={index}>{item}</th>
                </>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr
                key={item?.id}
                className={`${
                  item?.submittedWork?.length > 0
                    ? item?.status?.toLowerCase() === "approved"
                      ? "bg-green-lt"
                      : item?.status?.toLowerCase() === "ready"
                        ? "bg-yellow-lt"
                        : "bg-red-lt"
                    : "bg-red-lt"
                }`}
              >
                <td>{Index}</td>
                <td>{item?.deadline || "N/A"}</td>
                <td>{item?.taskName || "N/A"}</td>
                <td>{item?.agencyName || "N/A"}</td>
                <td>{item?.instructions || "N/A"}</td>
                <td>
                  {item.submittedWork && item.submittedWork.length > 0 ? (
                    item.submittedWork.map((image, index) => (
                      <div key={index}>
                        <a
                          href={image}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={image}
                        >
                          {image.length > 50
                            ? `${image.slice(0, 50)}...`
                            : image}
                        </a>
                      </div>
                    ))
                  ) : (
                    <span className="text-muted">-</span>
                  )}
                </td>
                {/* <td>{item?.createdByName || "N/A"}</td> */}
                <td>
                  <span
                    className={
                      item?.status?.toLowerCase() === "assigned"
                        ? "badge bg-orange text-orange-fg"
                        : item?.status?.toLowerCase() === "approved"
                        ? "badge bg-green text-green-fg"
                          : item?.status?.toLowerCase() === "ready"
                        ? "badge bg-yellow text-yellow-fg"
                        : "fw-bold"
                    }
                  >
                    {item?.status || "N/A"}
                  </span>
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MediaTaskTable;
